import React from 'react';
import Svg, {G, Path, Rect} from 'react-native-svg';

export const NovaAIFloatingIcon = ({color = '#2B78CA'}: {color?: string}) => (
  // Fixed size to 72x72 to match the blue circle exactly
  <Svg width="72" height="72" viewBox="0 0 72 72" fill="none">
    {/* Shifted elements up and left by 38/36px to align perfectly inside the new 72x72 box */}
    <G transform="translate(-38, -35.998)">
      <Rect x="38" y="35.998" width="72" height="72" rx="36" fill={color} />
      <Path
        d="M74 63.9981V58.6648H68.6666"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M78 70.6648V73.3315"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.6666 71.998H63.3333"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M84.6666 71.998H87.3333"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M84.6667 77.3314C84.6667 78.0386 84.3858 78.7169 83.8857 79.217C83.3856 79.7171 82.7073 79.998 82 79.998H69.7707C69.0635 79.9982 68.3854 80.2792 67.8854 80.7794L64.9494 83.7154C64.817 83.8478 64.6483 83.9379 64.4647 83.9744C64.2811 84.0109 64.0907 83.9922 63.9178 83.9205C63.7448 83.8489 63.597 83.7276 63.493 83.5719C63.3889 83.4163 63.3334 83.2333 63.3334 83.046V66.6647C63.3334 65.9575 63.6143 65.2792 64.1144 64.7791C64.6145 64.279 65.2928 63.998 66 63.998H82C82.7073 63.998 83.3856 64.279 83.8857 64.7791C84.3858 65.2792 84.6667 65.9575 84.6667 66.6647V77.3314Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M70 70.6648V73.3315"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  </Svg>
);
